var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoEdit24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_edit24x24",
    transform: "translate(-4 -4.025)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M4.6,20a.646.646,0,0,1-.6-.6.577.577,0,0,1,.6-.6H19.324a.6.6,0,1,1,0,1.2Z",
    transform: "translate(0 .025)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M7.5,16.5a.471.471,0,0,1-.1-.6l1.8-4.2c0-.1.1-.1.1-.2l7.1-7.1a1.267,1.267,0,0,1,1.8,0l1.4,1.4a1.268,1.268,0,0,1,0,1.8l-7.1,7.1c-.1.1-.1.1-.2.1L8.1,16.6H7.9a.6.6,0,0,1-.4-.1Z",
    transform: "translate(.025)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoEdit24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_edit24x24.d878744ef5e9b6ec966a8defd69918f8.svg";